if (!customElements.get('lasgym-refined-footer')) {
  customElements.define('lasgym-refined-footer', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.panels = [...this.querySelectorAll('[data-lg-footer-panel]')];
      this.mobileQuery = window.matchMedia('(max-width: 760px)');

      this.setMode = () => {
        const mobile = this.mobileQuery.matches;
        this.panels.forEach((panel) => {
          const summary = panel.querySelector('summary');
          if (mobile && panel.contains(document.activeElement) && document.activeElement !== summary) {
            summary.focus({ preventScroll: true });
          }
          panel.open = !mobile || Boolean(panel.querySelector('[data-lg-footer-notice]'));
          if (mobile) {
            summary.removeAttribute('tabindex');
          } else {
            summary.setAttribute('tabindex', '-1');
          }
        });
      };

      this.panels.forEach((panel) => {
        const summary = panel.querySelector('summary');
        summary.addEventListener('click', (event) => {
          if (!this.mobileQuery.matches) event.preventDefault();
        }, { signal });
        panel.addEventListener('toggle', () => {
          if (!this.mobileQuery.matches) {
            if (!panel.open) panel.open = true;
            return;
          }
          if (panel.open) {
            this.panels.forEach((other) => {
              if (other !== panel) other.open = false;
            });
          }
        }, { signal });
      });

      this.mobileQuery.addEventListener('change', this.setMode, { signal });
      this.querySelectorAll('[data-lg-footer-notice]').forEach((notice) => {
        const disclosure = notice.closest('.LGFooter__NewsletterDisclosure');
        if (disclosure) disclosure.open = true;
      });
      this.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-lg-footer-panel]');
        if (panel) panel.open = true;
      }, { signal });
      this.setMode();
      this.setAttribute('data-ready', '');
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  });
}
